<template>
  <aside v-show="true" class="side-nav-children">
    <div class="side-nav-header">
      <a href="#" target="_blank" class="site-logo">
        <img src="../assets/rl-main-logo.svg" />
      </a>
    </div>
    <div class="side-nav-content">
      <div class="content-container">
        <div class="content">
          <aside-menu-list @menu-click="menuClick" :menu="menu" />
        </div>
      </div>
    </div>
  </aside>
</template>

<script>
import { mapState } from "vuex";
import AsideMenuList from "@/modules/global/components/aside-menu/AsideMenuList.vue";

export default {
  name: "AsideMenuLayout",
  props: {
    menu: {
      type: Array,
      default: () => []
    }
  },
  components: {
    AsideMenuList
  },
  computed: {
    ...mapState(["isAsideVisible"])
  },
  methods: {
    menuClick(item) {
      return item;
    }
  }
};
</script>
